import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

const useQueryState = <T extends string | number>(key: string, defaultValue: T): [T, (newValue: T) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const value = useMemo(() => {
    const param = searchParams.get(key);
    return param !== null ? (Number(param) as T) : defaultValue;
  }, [searchParams, key, defaultValue]);

  const setValue = (newValue: T) => {
    setSearchParams(
      (prev) => {
        prev.set(key, String(newValue));
        return prev;
      },
      { replace: true }
    );
  };

  return [value, setValue];
};

export default useQueryState;
